module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "layer1"
  }, [_c('div', {
    staticClass: "info1"
  }, [_vm._v("实验编号：" + _vm._s(_vm.contractNo))]), _vm._v(" "), _c('div', {
    staticClass: "box3",
    class: _vm.getStatusClass(_vm.status)
  }, [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), _c('div', {
    staticClass: "layer2"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1010bd11","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/serviceProgressRefactor/components/ExperimentHeader.vue
// module id = 1537
// module chunks = 8